import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectIsModalOpen } from "../../../selectors/selectModalTabId";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionConsumePackage } from "../../item-packages/actionPackages";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionStore } from "../actionStore";
export var epicStoreBuyPackageRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionStore.BuyPackageRequest), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        var cost = action.cost, packageId = action.packageId, amount = action.amount;
        return deps
            .netSend({
            id: CommandCode.BuyPackage,
            props: {
                amount: action.amount,
                packageId: action.packageId,
                playerId: playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            var actions = [];
            var isStoreRewardDialogOpen = selectIsModalOpen(state, IdModal.CollectRewardsStore);
            if (isStoreRewardDialogOpen) {
                actions.push(actionModalClose(IdModal.CollectRewardsStore));
            }
            actions.push(actionConsumePackage(packageId, amount));
            actions.push(actionInventoryInfoRemoveResource(cost));
            return from(actions);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/epics/epicStoreBuyPackageRequest.ts
// module id = 2417
// module chunks = 3